import type { FC } from 'react';
import { useParams } from 'react-router';
import { usePublicStorageLocations } from 'src/apis/storage/use-public-storage-locations';
import { usePublicStorageOffers } from 'src/apis/storage/use-public-storage-offers';
import { useStorageOfferDetails } from 'src/apis/storage/use-storage-offer-details';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { storageLocationsOfferCreateParams } from 'src/pages/storage/locations-new/utils';
import { StorageOfferEditForm } from 'src/pages/storage/offers-new/edit/offer-edit-form';
import { storageOffersListDefaultParams } from 'src/pages/storage/offers-new/utils';

type Props = {
  storageServiceRoot: Successful<StorageServiceRootRequest>;
};

export const StorageOfferEdit: FC<Props> = ({ storageServiceRoot }) => {
  const { offerId } = useParams<{ offerId: string }>();

  const storageOffers = usePublicStorageOffers({
    storageServiceRoot,
    params: storageOffersListDefaultParams,
  });

  const storageOfferDetails = useStorageOfferDetails({
    storageOffers,
    offerId,
  });

  const storageLocations = usePublicStorageLocations({
    storageServiceRoot,
    params: storageLocationsOfferCreateParams,
  });

  if (
    !storageOffers.response ||
    !storageLocations.response ||
    !storageOfferDetails?.response
  ) {
    return <PageSpinner />;
  }

  return (
    <StorageOfferEditForm
      storageServiceRoot={storageServiceRoot}
      storageLocations={storageLocations}
      storageOfferDetails={storageOfferDetails}
    />
  );
};
